import React from 'react';
import { useDebounce } from 'react-use';

const useDebouncedState = (initialValue, ms = 100) => {
  const [val, setVal] = React.useState(initialValue);
  const [debouncedVal, setDebouncedVal] = React.useState(val);

  useDebounce(
    () => {
      setDebouncedVal(val);
    },
    ms,
    [val],
  );

  return [debouncedVal, setVal];
};

export default useDebouncedState;
